export const filterArrayOfObjectsByKeyAndValues = (
  array,
  objectKey,
  objectValuesArray
) => {
  return array.filter((item) => objectValuesArray.includes(item[objectKey]));
};
